import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { Icon } from "@iconify/react";
import Loading from "../../Shared/Loading";
import TeamCard from "./TeamCard";

const Team = () => {
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(`https://servercareseebd.careseebd.com/api/v1/teams`)
      .then((r) => r.json())
      .then((d) => { if (d?.data?.length) setTeams(d.data); })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Loading />;

  const reversed = [...teams].reverse();

  return (
    <section className="section-py bg-[#fafafa] overflow-hidden">
      {/* Header */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-14">
        <span className="inline-flex items-center gap-1.5 bg-indigo-50 text-indigo-600 border border-indigo-100 rounded-full px-4 py-1 text-xs font-semibold uppercase tracking-widest mb-5">
          <Icon icon="solar:stethoscope-bold" className="w-3.5 h-3.5" />
          Our Specialists
        </span>
        <h2 className="font-heading text-4xl sm:text-5xl font-extrabold text-gray-900 tracking-tight">
          Meet Our Expert Doctors
        </h2>
        <p className="mt-5 text-base text-gray-500 max-w-xl mx-auto">
          A world-class team of specialists dedicated to delivering exceptional care.
        </p>
      </div>

      {/* Marquee row 1 */}
      <Marquee pauseOnHover speed={32} gradient gradientColor={[250, 250, 250]} gradientWidth={100}>
        {teams.map((t) => <TeamCard key={t._id} team={t} />)}
      </Marquee>

      {/* Marquee row 2 */}
      <div className="mt-6">
        <Marquee pauseOnHover speed={32} direction="right" gradient gradientColor={[250, 250, 250]} gradientWidth={100}>
          {reversed.map((t) => <TeamCard key={t._id + "-r"} team={t} />)}
        </Marquee>
      </div>
    </section>
  );
};

export default Team;
